import { ISOCountryEntity } from '../entities/iso-country-entity';

export default class State {
  loaded = false;

  items: Array<ISOCountryEntity> = [];
}
